<ng-template [ngTemplateOutlet]="dropdown"></ng-template>
<ng-template #dropdown>
    <ng-content></ng-content>
</ng-template>